import {flightTypes} from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

var AgentFlight = {
    time: null,
    list: [],
    error: '',
    load: function (type) {
        return m.request({
            method: 'GET',
            url: '/api/agent/flights/' + type
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            AgentFlight.error = '';

            AgentFlight.time = response.time;
            AgentFlight.list = response.flights;

            storage.config = response.config;
            storage.flightType = type;

            server.initPing();

            return response;
        }, function (response) {
            if (response && response.message) {
                AgentFlight.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    showAlerts: function (key) {
        alert(AgentFlight.list[key].alerts.join("\n"));
    }
};

export var AgentFlightsPage = {
    controller: function () {

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = AgentFlight.load(storage.flightType || flightTypes.departure);

        return {
            data: data,
            topMenu: [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ]
        }
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: AgentFlight.time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", AgentFlight.error),
            m(".container[style='padding: 7px 15px;']", [
                m(".row", [
                    m(".col-xs-6[style='padding: 0 5px 0 10px']", [
                        m("button.btn.btn-success.btn-block[type='text']", {
                            class: storage.flightType == flightTypes.arrival ? 'active' : '',
                            onclick: function () {
                                interval.clearAll();
                                loader.show();
                                AgentFlight.load(flightTypes.arrival)
                            }
                        }, [
                            m("i.fa.fa-arrow-circle-down"),
                            m.trust('&nbsp;Прилет')
                        ])
                    ]),
                    m(".col-xs-6[style='padding: 0 10px 0 5px']", [
                        m("button.btn.btn-success.btn-block[type='text']", {
                            class: storage.flightType == flightTypes.departure ? 'active' : '',
                            onclick: function () {
                                interval.clearAll();
                                loader.show();
                                AgentFlight.load(flightTypes.departure)
                            }
                        }, [
                            m("i.fa.fa-arrow-circle-up"),
                            m.trust('&nbsp;Вылет')
                        ])
                    ])
                ])
            ]),
            m("table.table.table-bordered.table-condensed", [
                m("thead", [
                    m("tr", [
                        m("th.text-center", "Рейс"),
                        m("th.text-center", "Время"),
                        m("th", "")
                    ])
                ]),
                m("tbody", [
                    AgentFlight.list.map(function (flight, i) {
                        return m("tr", [
                            m("td", [
                                m("button.btn.btn-default.btn-block.btn-lg[type='button']",
                                    m("span[style='display:inline-block;padding-left:7px;']", [
                                        m('span', flight.flightNumber),
                                        m("br"),
                                        flight.type === flightTypes.departure ?
                                            m('img', {src: "/img/departure.png"}) : m.trust(flight.airportCode + '&nbsp;'),
                                        flight.type === flightTypes.departure ?
                                            m.trust('&nbsp;' + flight.airportCode) : m('img', {src: "/img/arrival.png"})
                                    ])
                                )
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", flight.time),
                                m("br"),
                                m("span", flight.date)
                            ]),
                            m("td.col-xs-2.text-center.v-center", [
                                flight.alerts.length > 0 ?
                                    m("button.btn.btn-warning.btn-lg[type='button']", {
                                        onclick: function () {
                                            AgentFlight.showAlerts(i);
                                        }
                                    }, [
                                        m("i.fa.fa-2x.fa-exclamation-triangle")
                                    ]) :
                                    m("button.btn.btn-info.btn-lg[type='button']", {
                                        disabled: true
                                    }, [
                                        m("i.fa.fa-2x.fa-exclamation-triangle")
                                    ])
                            ])
                        ])
                    })
                ])
            ])
        ]
    }
};
